<script>
import { createMenu, findMenu, deleteMenu, uploadCategoryImage } from '@/api/menu'
import { getBackimgs, publishBook, uploadImage } from '@/api/book'
import { getAdminInfoLogin } from '@/api/admin'

const DEFAULT_AVATAR =
  'http://oss.zhishijingling.com/haoliaodata/2023-07-12/22c77731c3ba439fa46020d3f74209c91689150310528_860.jpeg'

export default {
  name: 'Fabrication',
  data() {
    return {
      ifTipMode:false,
      DEFAULT_AVATAR,
      adminInfo: {},
      backimgs: [],
      categoryPopupVisible: false,
      categoryEditVisible: false,
      categoryUploadKey: 0,
      deletingCategory: false,
      showFreeEditor: false,
      freeUploadKey: 0,
      quickPriceVisible: false,
      quickPriceTemp: 0,
      quickPriceOptions: [0, 8.8, 12.8, 18.8, 28, 35, 38, 58, 68, 78, 88, 98, 128, 139, 159, 169, 179, 188, 189, 199, 258, 288, 388, 399],
      freeTimes : [{ text: '1分钟后', value: '1分钟后'}, { text: '30分钟后', value: '30分钟后' },{ text: '1小时后', value: '1小时后' },{ text: '3小时后', value: '3小时后' }
        ,{ text: '6小时后', value: '6小时后' },{ text: '12小时后', value: '12小时后' },{ text: '24小时后', value: '24小时后' },{ text: '36小时后', value: '36小时后' }
        ,{ text: '2天后', value: '2天后' },{ text: '3天后', value: '3天后' },{ text: '7天后', value: '7天后' },{ text: '10天后', value: '10天后' }
        ,{ text: '15天后', value: '15天后' },{ text: '30天后', value: '30天后' },{ text: '60天后', value: '60天后' }],
      picker: null,
      categories: [],
      selectedCategoryId: '',
      tempSelectedCategoryId: '',
      editCategory: {
        id: '',
        name: '',
        imgUrl: '',
        imgOssId: ''
      },
      uploadingCategoryImg: false,
      books: {
        watermark: 0,//内容水印（0=关 1=开）
        bookName: "",
        subName: "",
        contents: [
          { content: "", imgs: [], hidden: false }
        ],
        price: 0,
        nodisc: 0,//无折扣（0=关 1=开）
        backimg: "",
        menuid: "",
        freeImgs: [],
        freeimg: "",
        freeContent: "",
        soldtype: 1,//销售方式 1 资料，2 专辑 默认1资料
        freetime:"",//定时公开时间
        types:0,//作品类型 0 普通料 1 返还料 默认普通料，选择不对返还，则为返还料
      },
      ifFreeTime: false,//是否定时公开
    }
  },
  mounted () {
    this.loadAdminInfo()
    this.fetchCategories()
    this.fetchBackimgs()
  },
  methods: {

    async loadAdminInfo () {
      try {
        const res = await getAdminInfoLogin()
        const data = res && res.data ? res.data : {}
        this.adminInfo = data || {}
      } catch (e) {
        this.adminInfo = {}
      }
    },

    async fetchBackimgs () {
      try {
        const res = await getBackimgs()
        const arr = (res && res.data) ? res.data : res
        this.backimgs = Array.isArray(arr) ? arr.filter(Boolean) : []
      } catch (e) {
        this.backimgs = []
      }
    },

    async fetchCategories () {
      try {
        const res = await findMenu()
        const raw = (res && (res.data || res.rows || res.list)) || (res && res.data && (res.data.data || res.data.list)) || []
        const list = Array.isArray(raw) ? raw : (Array.isArray(res) ? res : [])
        this.categories = list.map(this.normalizeCategory).filter(i => i && i.id)
      } catch (e) {
        this.categories = []
      }
    },
    normalizeCategory (item) {
      if (!item) return null
      const id = String(item.id || item.categoryId || item.menuId || item.channelId || item.value || '')
      const name = String(item.name || item.categoryName || item.menuName || item.channelName || item.label || '')
      const imgUrl = String(item.imgUrl || item.imageUrl || item.icon || item.logo || item.channelImgUrl || item.channelImg || item.menuImg || item.pic || '')
      const imgOssId = String(item.imgOssId || item.ossId || item.channelImg || item.categoryImg || '')
      return { id, name, imgUrl, imgOssId, raw: item }
    },
    openCategoryPicker () {
      this.tempSelectedCategoryId = this.selectedCategoryId || ''
      this.categoryPopupVisible = true
    },
    closeCategoryPicker () {
      this.categoryPopupVisible = false
    },
    confirmCategoryPicker () {
      this.selectedCategoryId = this.tempSelectedCategoryId || ''
      this.books.menuid = this.selectedCategoryId || ''
      this.closeCategoryPicker()
    },
    openCategoryEditor (cat) {
      // 强制重建上传组件，清除上一次选择的文件预览
      this.categoryUploadKey += 1
      if (cat) {
        this.editCategory = {
          id: cat.id,
          name: cat.name || '',
          imgUrl: cat.imgUrl || '',
          imgOssId: cat.imgOssId || ''
        }
      } else {
        this.editCategory = { id: '', name: '', imgUrl: '', imgOssId: '' }
      }
      this.categoryEditVisible = true
    },
    closeCategoryEditor () {
      this.categoryEditVisible = false
      // 关闭时置空，避免下次新增/编辑残留
      this.editCategory = { id: '', name: '', imgUrl: '', imgOssId: '' }
      this.uploadingCategoryImg = false
      this.categoryUploadKey += 1
    },
    clearCategoryImage () {
      this.editCategory.imgUrl = ''
      this.editCategory.imgOssId = ''
      this.categoryUploadKey += 1
    },
    async confirmCategoryEditor () {
      const name = (this.editCategory.name || '').trim()
      if (!name) {
        this.$createToast({ type: 'warn', time: 1000, txt: '请输入分类名' }).show()
        return
      }
      if (name.length > 10) {
        this.$createToast({ type: 'warn', time: 1000, txt: '分类名最多10个字' }).show()
        return
      }
      try {
        const channelImg = this.editCategory.imgOssId || this.editCategory.imgUrl || ''
        const payload = {
          id: this.editCategory.id || undefined,
          name,
          imgUrl: this.editCategory.imgUrl || '',
          // 兼容后端字段命名
          categoryId: this.editCategory.id || undefined,
          categoryName: name,
          categoryImg: channelImg,
          channelName: name,
          channelImg: channelImg
        }
        await createMenu(payload)
        this.$createToast({ type: 'correct', time: 1000, txt: '保存成功' }).show()
        this.closeCategoryEditor()
        await this.fetchCategories()
      } catch (e) {
        this.$createToast({ type: 'warn', time: 1000, txt: '保存失败' }).show()
      }
    },
    async onCategoryFilesAdded (files) {
      const file = files && files[0]
      if (!file || file.ignore) return
      if (this.uploadingCategoryImg) return
      this.uploadingCategoryImg = true
      const loading = this.$createToast({ type: 'loading', time: 0, txt: '上传中...' })
      loading.show()
      try {
        const fd = new FormData()
        fd.append('file', file.file || file)
        const res = await uploadCategoryImage(fd)
        const data = (res && res.data) ? res.data : res
        const url = (data && (data.url || data.fileUrl || data.path)) || ''
        const ossId = (data && (data.ossId || data.ossID || data.id)) || ''
        if (!url) {
          this.$createToast({ type: 'warn', time: 1000, txt: '上传失败' }).show()
          return
        }
        this.editCategory.imgUrl = url
        this.editCategory.imgOssId = ossId ? String(ossId) : ''
        this.$createToast({ type: 'correct', time: 800, txt: '上传成功' }).show()
      } catch (e) {
        this.$createToast({ type: 'warn', time: 1000, txt: '上传失败' }).show()
      } finally {
        loading.hide()
        this.uploadingCategoryImg = false
      }
    },
    async onDeleteCategory (cat) {
      if (!cat || !cat.id) return
      this.$createDialog({
        type: 'confirm',
        title: '提示',
        content: '确认删除该分类？',
        onConfirm: async () => {
          if (this.deletingCategory) return
          this.deletingCategory = true
          const loading = this.$createToast({ type: 'loading', time: 0, txt: '删除中...' })
          loading.show()
          try {
            await deleteMenu(cat.id)
            if (this.selectedCategoryId === cat.id) {
              this.selectedCategoryId = ''
              this.tempSelectedCategoryId = ''
            }
            this.$createToast({ type: 'correct', time: 800, txt: '删除成功' }).show()
            await this.fetchCategories()
          } catch (e) {
            this.$createToast({ type: 'warn', time: 1000, txt: '删除失败' }).show()
          } finally {
            loading.hide()
            this.deletingCategory = false
          }
        },
        onCancel: () => {}
      }).show()
    },
    filesAdded(files) {
      let hasIgnore = false
      const maxSize = 1 * 1024 * 1024 // 1M
      for (let k in files) {
        const file = files[k]
        if (file.size > maxSize) {
          file.ignore = true
          hasIgnore = true
        }
      }
      hasIgnore && this.$createToast({
        type: 'warn',
        time: 1000,
        txt: 'You selected >1M files'
      }).show()
    },

    async onFreeFilesAdded (files) {
      await this.uploadContentImages(files, this.books.freeImgs)
    },

    openFreeEditor () {
      if (this.showFreeEditor) return
      this.showFreeEditor = true
      // 重建上传组件，避免上次选择的文件残留
      this.freeUploadKey += 1
    },

    closeFreeEditor () {
      this.showFreeEditor = false
      // 关闭时置空已填写内容与图片
      this.books.freeContent = ''
      this.books.freeImgs = []
      this.books.freeimg = ''
      this.freeUploadKey += 1
    },

    async onPaidFilesAdded (idx, files) {
      const item = this.books.contents && this.books.contents[idx]
      if (!item) return
      if (!Array.isArray(item.imgs)) this.$set(item, 'imgs', [])
      await this.uploadContentImages(files, item.imgs)
    },

    async uploadContentImages (files, targetArr) {
      const fileList = Array.isArray(files)
        ? files
        : Object.keys(files || {}).map(k => files[k]).filter(Boolean)
      if (!fileList.length) return
      if (!Array.isArray(targetArr)) return
      const max = 5
      const left = Math.max(0, max - (targetArr ? targetArr.length : 0))
      if (left <= 0) {
        this.$createToast({ type: 'warn', time: 1000, txt: '最多上传5张图片' }).show()
        return
      }
      const list = fileList.filter(f => f && !f.ignore).slice(0, left)
      if (!list.length) return

      const loading = this.$createToast({ type: 'loading', time: 0, txt: '上传中...' })
      loading.show()
      try {
        for (const f of list) {
          const fd = new FormData()
          fd.append('file', f.file || f)
          const res = await uploadImage(fd)
          const data = (res && res.data) ? res.data : res
          const url = (data && (data.url || data.fileUrl || data.path)) || ''
          if (url) targetArr.push(url)
        }
      } catch (e) {
        this.$createToast({ type: 'warn', time: 1000, txt: '上传失败' }).show()
      } finally {
        loading.hide()
      }
    },

    addPaidContent () {
      if (!Array.isArray(this.books.contents)) this.books.contents = []
      this.books.contents.push({ content: '', imgs: [], hidden: false })
    },

    closePaidContent (idx) {
      const item = this.books.contents && this.books.contents[idx]
      if (!item) return
      this.$set(item, 'content', '')
      this.$set(item, 'imgs', [])
      this.$set(item, 'hidden', true)
    },

    removeFreeImg (i) {
      if (!Array.isArray(this.books.freeImgs)) return
      this.books.freeImgs.splice(i, 1)
    },

    removePaidImg (idx, i) {
      const item = this.books.contents && this.books.contents[idx]
      if (!item || !Array.isArray(item.imgs)) return
      item.imgs.splice(i, 1)
    },

    openQuickPrice () {
      const current = Number(this.books.price || 0)
      this.quickPriceTemp = Number.isFinite(current) ? current : 0
      this.quickPriceVisible = true
    },
    closeQuickPrice () {
      this.quickPriceVisible = false
    },
    confirmQuickPrice () {
      this.books.price = this.quickPriceTemp
      this.closeQuickPrice()
    },
    pickQuickPrice (v) {
      this.quickPriceTemp = v
    },
    applyQuickPrice (v) {
      this.quickPriceTemp = v
      this.books.price = v
      this.closeQuickPrice()
    },

    // 是否返还：绑定作品类型（0 普通料 / 1 返还料）
    toggleTypes () {
      this.books.types = this.books.types ? 0 : 1
    },
    toggleNoDisc () {
      this.books.nodisc = this.books.nodisc ? 0 : 1
    },
    // 是否定时公开：仅前端展示，不提交
    toggleFreeTime () {
      this.ifFreeTime = !this.ifFreeTime
      if (!this.ifFreeTime) {
        this.books.freetime = ''
      }
    },
    toggleWatermark () {
      this.books.watermark = this.books.watermark ? 0 : 1
    },
    resetPublishForm () {
      this.selectedCategoryId = ''
      this.tempSelectedCategoryId = ''
      this.showFreeEditor = false
      this.quickPriceVisible = false
      this.quickPriceTemp = 0
      this.ifFreeTime = false
      this.books = {
        watermark: 0,
        bookName: '',
        subName: '',
        contents: [
          { content: '', imgs: [], hidden: false }
        ],
        price: 0,
        nodisc: 0,
        backimg: '',
        menuid: '',
        freeImgs: [],
        freeimg: '',
        freeContent: '',
        soldtype: 1,
        freetime: '',
        types: 0
      }
      this.freeUploadKey += 1
    },

    async onPublish () {
      const payload = {
        watermark: this.books.watermark,
        bookName: (this.books.bookName || '').trim(),
        subName: (this.books.subName || '').trim(),
        contents: (this.books.contents || []).filter(i => i && !i.hidden).map(i => ({
          content: (i && i.content) ? String(i.content).trim() : '',
          imgs: (i && Array.isArray(i.imgs)) ? i.imgs.slice(0, 5) : []
        })),
        price: Number(this.books.price || 0),
        nodisc: this.books.nodisc,
        backimg: this.books.backimg || '',
        menuid: this.selectedCategoryId || '',
        freeContent: (this.books.freeContent || '').trim(),
        freeImgs: Array.isArray(this.books.freeImgs) ? this.books.freeImgs.slice(0, 5) : [],
        soldtype: this.books.soldtype,
        types:this.books.types
      }

      if (!payload.bookName) {
        this.$createToast({ type: 'warn', time: 1000, txt: '请输入标题' }).show()
        return
      }
      // if (!payload.freeContent) {
      //   this.$createToast({ type: 'warn', time: 1000, txt: '请输入免费内容' }).show()
      //   return
      // }
      if (!payload.contents.length || !payload.contents.some(c => c.content || (c.imgs && c.imgs.length))) {
        this.$createToast({ type: 'warn', time: 1000, txt: '请至少填写一条收费内容' }).show()
        return
      }

      const loading = this.$createToast({ type: 'loading', time: 0, txt: '发布中...' })
      loading.show()
      try {
        const res = await publishBook(payload)
        const code = Number(res && res.code != null ? res.code : 200)
        if (code !== 200) {
          loading.hide()
          this.$createToast({ type: 'warn', time: 2000, txt: (res && res.msg) || '发布失败' }).show()
          return
        }
        loading.hide()
        this.$createToast({ type: 'correct', time: 1000, txt: '发布成功' }).show()
        this.resetPublishForm()
      } catch (e) {
        loading.hide()
        const msg = e && e.message ? e.message : '发布失败'
        this.$createToast({ type: 'warn', time: 2000, txt: msg }).show()
      }
    },

    showFreeTimeChoose() {
      if (!this.ifFreeTime) return
      if (!this.picker) {
        this.picker = this.$createPicker({
          title: '请选择',
          data: [this.freeTimes],
          onSelect: this.selectHandle,
          onCancel: this.cancelHandle
        })
      }
      this.picker.show()
    },
    selectHandle(selectedVal, selectedIndex, selectedText) {
      const val = Array.isArray(selectedVal) ? selectedVal[0] : selectedVal
      const text = Array.isArray(selectedText) ? selectedText[0] : selectedText
      this.books.freetime = (text || val || '').toString()
    },
    cancelHandle() {
      // 用户取消不做处理
    },
    submitHandler(e, model) {
      e.preventDefault()
      console.log('表单提交', model)
      // TODO: 调用接口提交 model（含 title, intro, freeContent, paidContent, price, noRefund, templateIndex）
    },
    validateHandler(result) {
      this.validity = result.validity
      this.valid = result.valid
    }
  }
}
</script>

<template>
  <!--制作料-->
  <div class="write-wraper">
    <div class="pMode">
      <div class="p_user">
        <div class="p_uContent">
          <div class="p_u_left">
            <img :src="adminInfo.headimgurl || DEFAULT_AVATAR">
          </div>
          <div class="p_u_right">
            <div class="p_u_r_name">{{ adminInfo.username || '' }}</div>
          </div>
        </div>
      </div>
      <div>
        <img src="https://oss.zhishijingling.com/jinriyouliao/home/openTopicimg.png" class="modeIconAlbum" @click="goUrl('/topic')" style="margin-right: 1rem;">
        <img src="https://oss.zhishijingling.com/jinriyouliao/jingjian.png" class="modeIcon">
      </div>
    </div>
  <!--    类目选择-->
    <div class="selected" @click="openCategoryPicker">
      <div class="s_list">
        <div class="s_l_left">分类</div>
        <div class="s_l_right">
          {{ (categories.find(c => c.id === selectedCategoryId) || {}).name || '选择(可选)' }}
        </div>
      </div>
    </div>
    <!--    注意事项-->
    <div class="tipsMode" v-if="ifTipMode">
      <div class="descBox">
        <div class="descTitle">注意事项</div>
        <div class="fontOrang">禁止出现违反国家法律法规禁止的内容:</div>
        <div class="item">（1）违反宪法确定的基本原则的;</div>
        <div class="item">（2）煽动民族仇恨、民族歧视，破坏民族团结的;</div>
        <div class="item">（3）破坏国家宗教政策,宣扬邪教和封建迷信的;</div>
        <div class="item">（4）散布谣言，扰乱社会秩序，破坏社会稳定的;</div>
        <div class="item">（5）散布淫移、色情、赌博、暴力、恐怖或者教唆犯罪的;</div>
        <div class="item">（6）侮辱或者诽谤他人，侵害他人合法权益的;</div>
        <div class="item">（7）含有法律、行政法规禁止的其他内容的。</div>
        <div>如有发现平台有权对其料内容进行下架和删除处理,感谢大家的配合。</div>
        <div class="konw" @click="ifTipMode=false">知道了</div></div>
    </div>
    <form class="cube-form book-form cube-form_invalid cube-form_fresh">
      <div class="cube-form-group">
        <p class="cube-form-group-legend"></p>
        <div class="cube-form-group-content">
          <div class="cube-form-item border-bottom-1px subtitle cube-form-item_required cube-form-item_invalid">
            <div class="cube-form-label">
              <span>标题</span>
            </div>
            <div class="cube-validator cube-form-field cube-validator_invalid">
              <div class="cube-validator-content">
                <div class="tips" @click="ifTipMode=!ifTipMode">
                  <img src="https://oss.zhishijingling.com/jinriyouliao/list/question.png" class="icon">注意事项</div>
                <cube-input v-model="books.bookName" class="inputCoutentBook" placeholder="请输入标题 50字内" :maxlength="50"></cube-input>
              </div>
              <div class="cube-validator-msg">
                <span class="cube-validator-msg-def">此为必填项</span></div>
            </div>
          </div>
          <!-- 子标题 -->
          <div class="cube-form-item border-bottom-1px subtitle">
            <div class="cube-form-label">
              <span>简介</span></div>
            <cube-input v-model="books.subName" class="inputCoutent" placeholder="请填写简介 60字内" :maxlength="60"></cube-input>
          </div>
        </div>
      </div>
      <div class="cube-form-group borderBottom subtitle">
        <p class="cube-form-group-legend"></p>
        <div class="cube-form-group-content">
          <div class="cube-form-item border-bottom-1px">
            <div class="cube-form-label">
              <span>免费内容</span>
            </div>
            <div class="cube-form-field">
              <div style="padding-top: 2px;"></div>
              <div class="edit-content">
                <div>
                  <div>
                    <template v-if="showFreeEditor">
                      <div class="edit-card">
                        <textarea v-model="books.freeContent" maxlength="2000" placeholder="请输入免费内容，2000字以内" class="card-text"></textarea>
                        <div class="close-btn" @click="closeFreeEditor">
                          <span>+</span>
                        </div>
                      </div>
                      <div class="img-uploader-row">
                        <div
                          v-for="(url, i) in books.freeImgs"
                          :key="url + '_' + i"
                          class="thumb"
                        >
                          <img :src="url" class="thumb-img">
                          <span class="thumb-remove" @click.stop="removeFreeImg(i)">×</span>
                        </div>
                        <cube-upload
                          :key="freeUploadKey"
                          class="free-upload"
                          :multiple="true"
                          :auto="false"
                          accept="image/*"
                          :max="5"
                          @files-added="onFreeFilesAdded"
                        />
                      </div>
                    </template>
                  </div>
                </div>
                <a v-if="!showFreeEditor" class="add_btn" @click.prevent="openFreeEditor"></a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cube-form-group">
        <p class="cube-form-group-legend"></p>
        <div class="cube-form-group-content">
          <div class="cube-form-item border-bottom-1px subtitle cube-form-item_required cube-form-item_invalid">
            <div class="cube-form-label">
              <span>收费内容</span></div>
            <div class="cube-validator cube-form-field cube-validator_invalid">
              <div class="cube-validator-content">
                <div class="edit-content">
                  <div v-for="(c, idx) in books.contents" :key="idx">
                    <template v-if="!c.hidden">
                      <div class="edit-card">
                        <textarea v-model="c.content" placeholder="请输入正文内容" class="card-text"></textarea>
                        <div class="close-btn" @click="closePaidContent(idx)">
                          <span>+</span>
                        </div>
                      </div>
                      <div class="img-uploader-row">
                        <div
                          v-for="(url, i) in (c.imgs || [])"
                          :key="url + '_' + i"
                          class="thumb"
                        >
                          <img :src="url" class="thumb-img">
                          <span class="thumb-remove" @click.stop="removePaidImg(idx, i)">×</span>
                        </div>
                        <cube-upload
                          class="paid-upload"
                          :multiple="true"
                          :auto="false"
                          accept="image/*"
                          :max="5"
                          @files-added="(files) => onPaidFilesAdded(idx, files)"
                        />
                      </div>
                    </template>
                  </div>
                  <div class="add_box" @click="addPaidContent">
                    <img src="https://oss.zhishijingling.com/jinriyouliao/add.png" class="icon">
                    <span>添加更多内容</span></div>
                  </div>
              </div>
              <div class="cube-validator-msg">
                <span class="cube-validator-msg-def">此为必填项</span></div>
            </div>
          </div>
        </div>
      </div>
      <div class="cube-form-group item-border">
        <p class="cube-form-group-legend"></p>
        <div class="cube-form-group-content">
          <div class="cube-form-item border-bottom-1px subtitle cube-form-item_required cube-form-item_invalid">
            <div class="cube-form-label">
              <span>售价</span></div>
            <div class="cube-validator cube-form-field cube-validator_invalid">
              <div class="cube-validator-content">
                <div class="set-price">
                  <div class="cube-input define-price">

                    <input v-model.number="books.price" type="number" placeholder="填写金额/元，0则为免费" class="cube-input-field">
                    </div>
                  <div class="right-btn" @click="openQuickPrice">快速定价</div></div>
              </div>
              <div class="cube-validator-msg">
                <span class="cube-validator-msg-def">此为必填项</span></div>
            </div>
          </div>
        </div>
      </div>
      <div class="cube-form-group item-border">
        <p class="cube-form-group-legend"></p>
        <div class="cube-form-group-content">
          <div class="cube-form-item border-bottom-1px">
            <div class="cube-form-label">
              <span>不对返还</span></div>
            <div class="cube-form-field">
<!--              <cube-switch v-model="books.ifRefund" class="freetime-switch"></cube-switch>-->
              <div
                class="switch freetime-switch"
                :class="books.types ? 'on' : 'close'"
                @click.stop="toggleTypes"
              ></div>
              <p style="text-align: left; font-size: 0.9rem; color: rgb(166, 165, 165);">在结束后可操作是否返还/正确收款</p></div>
          </div>
        </div>
      </div>
      <div class="cube-form-group item-border">
        <p class="cube-form-group-legend"></p>
        <div class="cube-form-group-content">
          <div class="cube-form-item border-bottom-1px">
            <div class="cube-form-label">
              <span>无折扣</span></div>
            <div class="cube-form-field">
              <div
                class="switch freetime-switch"
                :class="books.nodisc ? 'on' : 'close'"
                @click.stop="toggleNoDisc"
              ></div>
              <p style="text-align: left; font-size: 0.9rem; color: rgb(166, 165, 165);">选择无折扣，此料不参与设置的粉丝折扣</p></div>
          </div>
        </div>
      </div>
      <div class="cube-form-group item-border">
        <p class="cube-form-group-legend"></p>
        <div class="cube-form-group-content">
          <div class="cube-form-item border-bottom-1px">
            <div class="cube-form-label">
              <span>定时公开</span></div>
            <div class="cube-form-field">
              <div
                class="switch freetime-switch"
                :class="ifFreeTime ? 'on' : 'close'"
                @click.stop="toggleFreeTime"
              ></div>
              <p style="text-align: left; font-size: 0.9rem; color: rgb(166, 165, 165);">所设定时间后免费查看内容</p>
              <div v-if="ifFreeTime" class="cube-select freetime" @click.stop="showFreeTimeChoose">
                <span class="cube-select-placeholder" >{{ books.freetime || '请选择公开时间' }}</span>
                <i class="cube-select-icon"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cube-form-group item-border">
        <p class="cube-form-group-legend"></p>
        <div class="cube-form-group-content">
          <div class="cube-form-item border-bottom-1px">
            <div class="cube-form-label">
              <span>内容水印</span></div>
            <div class="cube-form-field">
              <div
                class="switch freetime-switch"
                :class="books.watermark ? 'on' : 'close'"
                @click.stop="toggleWatermark"
              ></div>
              <p style="text-align: left; font-size: 0.9rem; color: rgb(166, 165, 165);">开启后水印格式为作者名，内容将覆盖水印</p></div>
          </div>
        </div>
      </div>
      <div class="cube-form-group">
        <p class="cube-form-group-legend"></p>
        <div class="cube-form-group-content">
          <div class="cube-form-item border-bottom-1px" style="padding-top: 0px;">
            <div class="cube-form-label" style="display: none;">
              <span></span>
            </div>
            <div class="cube-form-field">
              <div class="subtitle" style="text-align: left;">个性模板</div>
              <p style="text-align: left; font-size: 0.9rem; color: rgb(166, 165, 165);">精美个性模板多选一</p>
              <div class="backimg">
                <div
                  v-for="(img, i) in backimgs"
                  :key="i"
                  class="item"
                  :class="{ active: books.backimg === img }"
                  @click="books.backimg = img"
                >
                  <img :src="img">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
     <div class="cube-form-item border-bottom-1px">
        <div class="cube-form-label" style="display: none;">
          <span></span>
        </div>
        <div class="cube-form-field">
          <button type="button" class="cube-btn make-btn cube-btn-inline" @click="onPublish">
            生成料码</button></div>
      </div>
    </form>
    <div >
      <bottom-tab-bar />
    </div>
    <div class="iphoneX-bttom" style="height: 4rem;"></div>

    <div>
      <!--选择分类-->
      <div v-show="categoryPopupVisible" class="cube-popup cube-popup_mask cube-picker" style="z-index: 100;">
        <div class="cube-popup-mask" @click="closeCategoryPicker"></div>
        <div class="cube-popup-container">
          <div class="cube-popup-content">
            <div class="cube-picker-panel cube-safe-area-pb">
              <div class="cube-picker-choose border-bottom-1px">
                <span class="cube-picker-cancel" @click="closeCategoryPicker">取消</span>
                <span class="cube-picker-confirm" @click="confirmCategoryPicker">确定</span>
                <div class="cube-picker-title-group">
                  <h1 class="cube-picker-title">请选择分类</h1></div>
              </div>
              <div>
                <div class="scroll-list-wrap">
                  <div class="cube-scroll-wrapper">
                    <div class="cube-scroll-content" style="transition-timing-function: cubic-bezier(0.165, 0.84, 0.44, 1); transition-duration: 0ms; transform: translate(0px, 0px) scale(1) translateZ(0px);">
                      <div class="cube-scroll-list-wrapper" style="min-height: 0px;">
                        <div class="cube-radio-group border-top-1px border-bottom-1px">
                          <div
                            v-for="cat in categories"
                            :key="cat.id"
                            data-pos="left"
                            class="cube-radio"
                            :class="{ 'cube-radio_selected': tempSelectedCategoryId === cat.id }"
                            @click="tempSelectedCategoryId = cat.id"
                          >
                            <label class="cube-radio-wrap border-bottom-1px">
                              <input type="radio" class="cube-radio-input" :value="cat.id">
                              <span class="cube-radio-ui cubeic-round-border"><i></i></span>
                              <div class="list">
                                <div class="l_left">
                                  <img :src="cat.imgUrl">
                                  <div>{{ cat.name }}</div>
                                </div>
                                <div class="l_right">
                                  <img
                                    src="https://oss.zhishijingling.com/jinriyouliao/delete1.png"
                                    class="delete"
                                    @click.stop="onDeleteCategory(cat)"
                                  >
                                  <img
                                    src="https://oss.zhishijingling.com/jinriyouliao/edit1.png"
                                    class="edit"
                                    @click.stop="openCategoryEditor(cat)"
                                  >
                                </div>
                              </div>
                            </label>
                          </div>
                        </div>
                      </div>
                      </div>
                    </div>
                </div>
                <div class="addTeacher" @click="openCategoryEditor()">
                  <img src="https://oss.zhishijingling.com/jinriyouliao/popup/addTeacher.png">
                  <div>新增分类</div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--新增编辑分类-->
      <div v-show="categoryEditVisible" class="cube-popup cube-popup_mask cube-picker" style="z-index: 100;">
        <div class="cube-popup-mask" @click="closeCategoryEditor"></div>
        <div class="cube-popup-container">
          <div class="cube-popup-content">
            <div class="cube-picker-panel cube-safe-area-pb">
              <div class="cube-picker-choose border-bottom-1px">
                <span class="cube-picker-cancel" @click="closeCategoryEditor">取消</span>
                <span class="cube-picker-confirm" @click="confirmCategoryEditor">确定</span>
                <div class="cube-picker-title-group">
                  <h1 class="cube-picker-title">新增/编辑分类</h1></div>
              </div>
              <div>
                <div class="editor">
                  <div class="input">
                    <div class="i_title">分类名：</div>
                    <cube-input v-model="editCategory.name" class="i_input" placeholder="请输入分类名 10字内" :maxlength="10"></cube-input>
                  </div>
                  <div class="input category-image-row">
                    <div v-if="editCategory.imgUrl" class="category-preview category-preview--inplace">
                      <img :src="editCategory.imgUrl" class="category-preview-img">
                      <span class="category-preview-remove" @click.stop="clearCategoryImage">×</span>
                    </div>
                    <cube-upload
                      v-else
                      :key="categoryUploadKey"
                      class="category-upload"
                      :multiple="false"
                      :auto="false"
                      accept="image/*"
                      :max="1"
                      @files-added="onCategoryFilesAdded"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 快速定价弹出窗   -->
      <div v-if="quickPriceVisible" class="cube-popup cube-popup_mask cube-picker" style="z-index: 110;">
        <div class="cube-popup-mask" @click="closeQuickPrice"></div>
        <div class="cube-popup-container">
          <div class="cube-popup-content">
            <div class="cube-picker-panel cube-safe-area-pb">
              <div class="cube-picker-choose border-bottom-1px">
                <span class="cube-picker-cancel" @click="closeQuickPrice">取消</span>
                <div class="cube-picker-title-group" style="flex: 1 1 0%;">
                  <h1 class="cube-picker-title">快速定价</h1></div>
                </div>
              <div>
                <div class="priceModal">
                  <div
                    v-for="(p, i) in quickPriceOptions"
                    :key="String(p) + '_' + i"
                    class="p_item"
                    :class="{ active: quickPriceTemp === p }"
                    @click="applyQuickPrice(p)"
                  >
                    {{ p === 0 ? '免费' : p }}
                    <img v-if="quickPriceTemp === p" src="https://oss.zhishijingling.com/jinriyouliao/home/selected.png">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>
   </div>

</template>

<style>
.img-uploader-row{
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: .5rem;
}
.img-uploader-row .cube-upload{
  margin: 0;
}
.img-uploader-row .cube-upload-btn{
  margin: 0;
}
.free-upload .cube-upload-file,
.paid-upload .cube-upload-file{
  display: none !important;
}
.thumb{
  position: relative;
  width: 3.5rem;
  height: 3.5rem;
  border-radius: .25rem;
  overflow: hidden;
  background: #f5f5f5;
}
.thumb-img{
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.thumb-remove{
  position: absolute;
  top: -.35rem;
  right: -.35rem;
  width: 1.1rem;
  height: 1.1rem;
  line-height: 1.1rem;
  text-align: center;
  background: rgba(0,0,0,.6);
  color: #fff;
  border-radius: 50%;
  font-size: .95rem;
}
.quick-price-body{
  padding: .8rem .8rem 1rem;
}
.quick-price-list{
  display: flex;
  flex-wrap: wrap;
  gap: .6rem;
}
.quick-price-item{
  padding: .45rem .7rem;
  border: 1px solid #e6e6e6;
  border-radius: .4rem;
  color: #333;
  font-size: .95rem;
  background: #fff;
}
.quick-price-item.active{
  border-color: #f74905;
  color: #f74905;
}
.category-image-row{
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  text-align: left;
}
.category-image-row > *{
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.category-preview{
  position: relative;
  display: inline-block;
}
.category-preview--inplace{
  width: 6rem;
  height: 6rem;
  margin: 0;
}
.category-preview-img{
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: .25rem;
  display: block;
}
.category-preview-remove{
  position: absolute;
  top: -.4rem;
  left: -.4rem;
  width: 1.2rem;
  height: 1.2rem;
  line-height: 1.2rem;
  text-align: center;
  background: rgba(0,0,0,.6);
  color: #fff;
  border-radius: 50%;
  font-size: 1rem;
}
.edit-card{
  position: relative;
  width: 100%;
  margin: 10px 0;
  border: .0831rem solid #f74905;
  border-radius: .25rem;
  padding: 1rem .7rem;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/fabrication.vue